import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './styles.module.scss';
import services from '../../services';

const ParticipanteCard = ({ participante, remover }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Nome:</div>
      <div className={styles.info}>{participante.nome}</div>
      <div className={styles.title}>Email:</div>
      <div className={styles.info}>{participante.email}</div>
      <div className={styles.title}>CPF</div>
      <div className={styles.info}>{services.mask.cpf(participante.cpf)}</div>
      <div className={styles.title}>Cargo</div>
      <div className={styles.info}>{participante.cargo}</div>
      <div className={styles.title}>Perfil de acesso</div>
      <div className={styles.info}>
        {participante.perfilAcesso == 'AcessaAdmin'
          ? 'Não Definido'
          : participante.perfilAcesso}
      </div>
      <div className={styles.title}>Código Parceiro BV</div>
      <div className={styles.info}>{participante.codigoParceiro ?? '--'}</div>
      <div className={styles.title}>Razão Social</div>
      <div className={styles.info}>{participante.nomeParceiro}</div>
      <button
        className={styles.apagar}
        onClick={() => {
          remover(participante.cpf);
        }}
        hidden={!remover}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

export default ParticipanteCard;
